'use strict';
angular.module('tenantTransferModule', [])
    .controller('tenantTransferCtrl', ["$scope", "$q", "trsHttpService", "$modalInstance", "$filter", "modalDialog", "selectedTenat",
        function($scope, $q, trsHttpService, $modalInstance, $filter, modalDialog, selectedTenat) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    page: {
                        CURRPAGE: 1,
                        PAGESIZE: 20
                    },
                    isExpand: true
                }
                $scope.data = {
                    tenantList: [],
                    selectedArray: selectedTenat
                }
            }
            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                let defer = $q.defer();
                let params = {
                    'serviceid': 'mlf_tenant',
                    'methodName': 'queryTenants',
                    'CURRPAGE': $scope.status.page.CURRPAGE,
                    'PAGESIZE': $scope.status.page.PAGESIZE,
                    'STATUS': 0
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                    $scope.status.page = data.PAGER;
                    $scope.data.tenantList = $scope.status.page.CURRPAGE == 1 ? [].concat(data.DATA.map((_item) => {
                        _item.selected = false;
                        return _item;
                    })) : $scope.data.tenantList.concat(data.DATA.map((_item) => {
                        _item.selected = false;
                        return _item;
                    }));
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [findObjFromArray description] 根据属性值查找元素
             * @param  {[type]} arr      [description] 数组
             * @param  {[type]} property [description] 属性名
             * @param  {[type]} value    [description]属性值
             * @return {[type]}          [description]
             */
            function findObjFromArray(arr, property, value) {
                if (arr.length == 0) {
                    return false;
                }
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i][property] == value) {
                        return arr[i];
                    }
                }
                return false;
            }
            /**
             * [directlyToRight description] 直接选择
             * @param  {[type]} item [description] 租户
             * @return {[type]}      [description]
             */
            $scope.directlyToRight = function(item) {
                if (item.selected) {
                    return;
                }
                item.selected = true;
                let _item = angular.copy(item);
                _item.selected = false;
                $scope.data.selectedArray.push(_item);
            }
            /**
             * [toRight description] 选择
             * @return {[type]} [description]
             */
            $scope.toRight = function() {
                $scope.data.tenantList.forEach((item) => {
                    if (item.selected) {
                        if (!findObjFromArray($scope.data.selectedArray, 'TENANTID', item.TENANTID)) {
                            let _item = angular.copy(item);
                            _item.selected = false;
                            $scope.data.selectedArray.push(_item);
                        }
                        item.selected = false;
                    }
                });
            }
            /**
             * [toLeft description] 取消选择
             * @return {[type]} [description]
             */
            $scope.toLeft = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.filter((_item) => {
                    if (_item.selected) {
                        let tenantObj = findObjFromArray($scope.data.tenantList, 'TENANTID', _item.TENANTID);
                        if (tenantObj) {
                            tenantObj.selected = false;
                        }
                    }
                    return !_item.selected;
                })
            }
            /**
             * [directlyToLeft description] 直接取消选择
             * @param  {[type]} item [description] 租户
             * @return {[type]}      [description]
             */
            $scope.directlyToLeft = function(item) {
                let tenantObj = findObjFromArray($scope.data.tenantList, 'TENANTID', item.TENANTID);
                if (tenantObj) {
                    tenantObj.selected = false;
                }
                item.selected = false;
            }
            /**
             * [reset description] 重置
             * @return {[type]} [description]
             */
            $scope.reset = function() {
                $scope.data.selectedArray = [];
                $scope.data.tenantList = $scope.data.tenantList.map((_item) => {
                    _item.selected = false;
                    return _item
                })
            }
            /**
             * [scrollShowMore description] 滚动加载更多
             * @return {[type]} [description]
             */
            $scope.scrollShowMore = function() {
                if ($scope.status.page.PAGECOUNT == $scope.status.page.CURRPAGE) {
                    return;
                }
                $scope.status.page.CURRPAGE++;
                initData();
            }
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            }
            /**
             * [submit description] 提交
             * @return {[type]} [description]
             */
            $scope.submit = function() {
                $modalInstance.close($scope.data.selectedArray);
            }
        }
    ]);